import { ACTION } from './action-types';
import * as actions from './action-types';
import { ActionMap } from 'app/area/my-downloads/types';
import { ExportsModalState } from 'app/area/my-downloads/exports/export-to-zip-modal/types-store';

export const INITIAL_EXPORTS_MODAL_STATE: any = {
  exportsModal: {
    fetching: false
  }
};

export const reducers: ActionMap = {

  [ACTION.REQUEST_EXPORT_CASES]: (state: ExportsModalState, action: actions.RequestExportCases): ExportsModalState => {

    return {
      ...state,
      exportsModal: {
        ...state.exportsModal,
        fetching: true
      }
    };
  },

  [ACTION.RECEIVE_EXPORT_CASES]: (state: ExportsModalState, action: actions.ReceiveExportCases): ExportsModalState => {

    return {
      ...state,
      exportsModal: {
        ...state.exportsModal,
        fetching: false
      }
    };
  },

  [ACTION.FAIL_EXPORT_CASES]: (state: ExportsModalState, action: actions.FailExportCases): ExportsModalState => {
    
    return {
      ...state,
      exportsModal: {
        ...state.exportsModal,
        fetching: false
      }
    };
  }
};
